import axiosClient from './axiosClient';

const itemService = {
    getPublicItems: () => axiosClient.get('/public/items'),
    getHomepageItems: () => axiosClient.get('/public/items/homepage'),
    getBestSellers: () => axiosClient.get('/public/items/best-sellers'),
    
    getItemsByMenuId: (menuId) => axiosClient.get(`/public/items/menu/${menuId}`),
    getItemDetail: (id) => axiosClient.get(`/public/items/${id}`),
    getItemsByCategoryId: (categoryId) => {
        let url = `/public/items/category/${categoryId}`; 
        return axiosClient.get(url);
    },
    getHotDeals: () => axiosClient.get('/public/sales/hot-deals'),
    getHomepageMenuGroups: () => axiosClient.get('/public/items/homepage/groups'),
};

export default itemService;